<template>
  <div>
    <h1>Politicians Ranked by Twitter Sentiment</h1>
	<h3>Made with ❤️ by Varun487, Shashwath-kumar and hriti24k</h3>
  </div>
</template>

<script>
export default {
  name: 'Base',
}
</script>

<style scoped>
</style>
